import {
  GET_CONTENT_CONFIG,
  GET_CONTENT_CONFIG_SUCCESS,
  GET_CONTENT_CONFIG_ERROR,
} from "../../constants/action-types";

export const contentConfigInitialState = {
  content: {
    general: {
      header: "",
      description: {
        message: "",
        link: { name: "", route: "" },
      },
    },
    usaStatesList: [],
    available: {
      noContent: {
        message: "",
        link: { name: "", route: "" },
      },
    },
    claimed: {
      noContent: { message: "" },
    },
    questionnaire: {
      requiredPage: {
        header: "",
        description: { step: "", message: "" },
      },
      optionalPage: {
        header: "",
        description: { step: "", message: "" },
      },
      modalWindows: {
        continueModal: {
          header: "",
          message: "",
          confirmButton: "",
          cancelButton: "",
        },
        leaveModal: {
          message: "",
          confirmButton: "",
          cancelButton: "",
        },
      },
    },
    settings: {
      header: "",
      description: "",
      warningPersonalInfoSave: "",
    },
    toast: {
      badRequest: "",
      unauthorized: "",
      serverError: "",
      unexpected: "Something went wrong",
      failRetrieve: "",
      failSend: "",
      successClaimSave: "",
      successAddressSave: "",
    },
  },
  isFetching: true,
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_CONTENT_CONFIG: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_CONTENT_CONFIG_SUCCESS: {
      return {
        content: payload.content,
        isFetching: false,
      };
    }
    case GET_CONTENT_CONFIG_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
